import React, { useEffect, useState } from 'react';
import { Dialog, IconButton, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { CheckBox, DateBox, NumberBox, SelectBox, TagBox, TextArea } from 'devextreme-react';
import { TextBox } from 'devextreme-react/text-box';
import saveIconWhite from '../../../images/save-icon-white.svg';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../redux/modal/modalSlice';
import { createCustomer, editCustomer } from '../../../redux/customers/thunks';
import { addVehicleToContract, createContractVehicle, createSimpleContract, getContract, updateContractVehicle } from '../../../redux/contract/thunks';
import { errorHandler } from '../../../commonFunctions/errorHandler';
import { baseRequest } from '../../../fetch/basicThunk';
import { QUERY_GET_BRANDS, QUERY_GET_MASTER_CUSTOMERS, QUERY_GET_MODELSBYBRANDID } from '../../../fetch/constantQueries';
import { RequiredRule, Validator } from 'devextreme-react/validator';

function InputWrapper(props) {
  const { classes, label } = props;
  return (
    <div className="input-admin">
      <label className={classes?.label}>{label}</label>
      <div style={{ width: '75%' }} className="dx-field-value">
        {props.children}
      </div>
    </div>
  );
}

function VehicleDialog(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { contract, dialogSize, open, onClose } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const dialogStyles = {
    // width: operation !== 'delete' ? (dialogSize?.width || '550px') : '550px',
    // height: operation !== 'delete' ? (dialogSize?.height || '180px') : '180px',
    width: '550px',
    height: '100%',
    minWidth: 'max-content',
  };

  const buttonStyles = {
    padding: '6px 16px',
    fontSize: '13px',
    margin: 'auto',
    marginTop: '5px',
    borderRadius: '0',
    color: 'white',
    backgroundColor: '#3B5158',
  };

  const buttonSaveStyles = {
    padding: '6px 16px',
    fontSize: '13px',
    marginRight: '16px',
    marginTop: '5px',
    float: 'right',
    borderRadius: '0',
    color: 'white',
    backgroundColor: '#3B5158',
  };

  const closeButton = {
    position: 'absolute',
    right: '6px',
    top: '0px',
  };


  const [dataForm, setDataForm] = useState({});
  const [formOperation, setFormOperation] = useState(null);
  const [showDialog, setShowDialog] = useState(false);

  const [title, setTitle] = useState();
  const [btnTitle, setBtnTitle] = useState();
  const [operation, setOperation] = useState();

  useEffect(() => {
    fetchBrands();
    if (open && contract) {
      
      if(contract?.brandId){
        fetchModelsByBrandID(contract?.brandId);
      }

      setDataForm({
        contractId: contract.id,
        brandId: contract.brandId,
        modelId: contract.modelId,
        year: contract.year,
        plate: contract.plate,
        color: contract.color,
        chassis: contract.chassisNumber
      });

      setTitle((contract?.modelId != null && contract?.modelId > 0 ) ? 'Editar veiculo' : 'Cadastrar veiculo');
      setBtnTitle((contract?.modelId != null && contract?.modelId > 0 ) ? 'Editar' : 'Salvar');
      setOperation(contract.customerPhone == null ? 'delete' : '');
    }
  }, [open]);

  

  function onChange(main, value) {
    if (value == null || value == undefined) return;
    if (main.toLowerCase() === 'phone') value = value.replace(/[^0-9+]/g, '');
    if (main.toLowerCase() === 'cep') value = value.replace(/[^0-9]/g, '');

    setDataForm((prevState) => ({ ...prevState, [main]: value }));
  }
  async function handleSubmit() {
    setIsSubmitting(true);

    // Validação de Campos

    if (!dataForm.brandId) {
      dispatch(openModal({ type: 'warning', message: `O campo Marca é obrigatório` }));
      setIsSubmitting(false);
      return false;
    }
    if (!dataForm.modelId) {
      dispatch(openModal({ type: 'warning', message: `O campo Modelo é obrigatório` }));
      setIsSubmitting(false);
      return false;
    }
    
    // if (!dataForm.chassis || dataForm.chassis.trim() === '') {
    //   dispatch(openModal({ type: 'warning', message: `O campo Chassi é obrigatório` }));
    //   setIsSubmitting(false);
    //   return false;
    // }

    try {
      if (contract?.modelId == null || contract?.modelId <= 0 ) {
        dispatch(createContractVehicle({ body: dataForm })).then((data) => {
            if(data.error)
              dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
              dispatch(getContract({ query: '?plate=' + contract.customerPhone }));
              onClose();
            }
            setIsSubmitting(false);
        })
      } else {
        //await dispatch(editCustomer({ body: customerDataForm }));
        const editCustomerParams ={
            param: contract.id,
            customerId: contract.id,
            body:dataForm
        }
        dispatch(updateContractVehicle({ body: dataForm })).then((data) => {
            if(data.error)
              dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
              dispatch(getContract({ query: '?plate=' + contract.customerPhone }));
              onClose();
            }
            setIsSubmitting(false);
        })
      }
      
    } catch (err) {
      dispatch(openModal(errorHandler(err)));
      setIsSubmitting(false);
    }
  }

const [brands, setBrands] = useState();
const [modelsFiltered, setModelsFiltered] = useState();

  

  async function fetchBrands(){
      const brands = await baseRequest({}, dispatch, QUERY_GET_BRANDS, "GET");
      setBrands(brands);
  }

  function onBrandChange(value){
    onChange('brandId', value)
    if(value != null || value != undefined){
      fetchModelsByBrandID(value);
    }
    else{
      setModelsFiltered(null)
    }
  }

  async function fetchModelsByBrandID(brandId){
      const models = await baseRequest({param: brandId}, dispatch, QUERY_GET_MODELSBYBRANDID, "GET");
      setModelsFiltered(models);
  } 

  return (
    <Dialog maxWidth={'xl'} open={open} onClose={onClose} style={{ borderRadius: 0 }}>
      <div style={dialogStyles}>
        <DialogTitle disableTypography className="titleStyles">
          {title}
          {/* {operation !== 'delete' && <IconButton onClick = {onClose} style = {closeButton}> <Close style={{color: "white"}}/> </IconButton>} */}
          <IconButton onClick={onClose} style={closeButton}>
            <Close />
          </IconButton>
        </DialogTitle>
        <hr class="MuiDivider-root" style={{ width: '100%', backgroundColor: 'black' }}></hr>

        <DialogContent>
          <div style={{ display: 'flex', flexFlow: 'column', rowGap: '1rem' }}>

          <SelectBox
              label={"Marca"}
              name="Marca"
              dataSource={brands}
              showClearButton={true}
              // acceptCustomValue
              // onCustomItemCreating={customItemCreating}
              value={dataForm?.brandId}
              displayExpr={"brandName"}
              valueExpr={"brandId"}
              onValueChanged={(e) => onBrandChange(e.value)}
              searchEnabled={true}
            ></SelectBox>

            <SelectBox
              label={"Modelo"}
              name="Modelo"
              dataSource={modelsFiltered}
              showClearButton={true}
              // acceptCustomValue
              // onCustomItemCreating={customItemCreating}
              value={dataForm?.modelId}
              displayExpr={"modelName"}
              valueExpr={"modelId"}
              onValueChanged={(e) => onChange('modelId', e.value)}
              searchEnabled={true}
              disabled={modelsFiltered == null || modelsFiltered == undefined || modelsFiltered == []}
            ></SelectBox>

            {/* <TextBox
              label={'CPF*'}
              key={'CPF'}
              //disabled={editMode}
              name="CPF"
              mask="000.000.000-00"
              placeholder="000.000.000-00"
              showMaskMode="onFocus"
              maskRules={{ 0: /[0-9]/ }}
              value={dataForm?.CPF}
              onValueChanged={(e) => onChange('CPF', e.value)}
            ></TextBox> */}

            <TextBox label={'Ano/Modelo'} key={'Year'} name="Year" value={dataForm?.year} onValueChanged={(e) => onChange('year', e.value)}></TextBox>
            <TextBox label={'Placa'} key={'Placa'} name="Placa" value={dataForm?.plate} onValueChanged={(e) => onChange('plate', e.value)}></TextBox>
            <TextBox label={'Chassi'} key={'Chassi'} name="Chassi" value={dataForm?.chassis} onValueChanged={(e) => onChange('chassis', e.value)}>
              {/* <Validator><RequiredRule message="O campo Chassi é obrigatório" /></Validator> */}
            </TextBox>
            <TextBox label={'Cor'} key={'Cor'} name="Cor" value={dataForm?.color} onValueChanged={(e) => onChange('color', e.value)}></TextBox>

          </div>
        </DialogContent>
        <DialogActions>
          <div style={{ display: 'flex', gap: '1rem', paddingRight: 16 }}>
            {operation === 'delete' ? (
              <>
                <Button disabled={isSubmitting} variant="contained" onClick={onClose}>
                  Cancelar
                </Button>

                <Button disabled={isSubmitting} variant="contained" color="primary" onClick={handleSubmit} startIcon={<img src={saveIconWhite} />}>
                  Salvar
                </Button>
              </>
            ) : (
              <Button disabled={isSubmitting} variant="contained" color="primary" onClick={handleSubmit} startIcon={<img src={saveIconWhite} />}>
                {btnTitle}
              </Button>
            )}
          </div>
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default VehicleDialog;